import React, { createRef, Component } from 'react';
import { Input, Alert, Button, notification, Tabs, Row, Col, Dropdown, Icon, Popconfirm, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import '../MyProfile/profile.css';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const customPanelStyle = {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 7px 64px 0 rgb(0 0 0 / 7%)',
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};
const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};


let Phoneid = 0;
let Emailid = 0;
class ContactInfoForm extends Component {
    selectphonecountryIDRef = createRef()
    constructor(props) {
        super(props)
        this.state = {
            Phones: '',
            Emails: '',
            Email: '',
            PrimaryEmailSelected: 0,
            PrimarySelected: -1,
            Radioid: 0,
            EmailRadioid: 0,
            EmailId: '',
            EmailTypeId: '',
            currentPrimaryEmail: '',
            currentPrimaryPhone: '',
            personGUID: '',
            email: '',
            needUpdatePhoneKeys: [],
            needUpdateEmailKeys: [],
            isUndeliverable: false,
            emailType: []
        }
    }

    componentWillUnmount = () => {
        Phoneid = 0
    }

    componentDidMount = () => {
        this.props.actions.getCommunicationTypes()
        this.props.actions.getPhoneCountries()
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getProfileInfo(personGUID)
    }

    cancelActions = (e) => {
        // let loggedinUser = JSON.parse(localStorage.getItem('user'))
        // let personGUID = loggedinUser.personGuid;
        // this.props.actions.getProfileInfo(personGUID)

        this.props.actions.getAlumniInfo(this.props.profileinfo.profile.personGuid, this.props.isspecialist ? "" : "admin")
        e.preventDefault();
    }

    getPhoneCode = () => {
        if (this.props.phonecode) {
            let phonecode = this.props.phonecode.sort((a, b) => a.name.localeCompare(b.name))
            return phonecode.map((k, index) => {
                return (
                    <option key={index} value={k.id}>{k.name}</option>
                )
            })
        }

    }

    componentWillReceiveProps = (nextprops) => {
        if (nextprops.profileinfo) {
            if ((this.props.profileinfo ? this.props.profileinfo.profile.personId : "") !== nextprops.profileinfo.profile.personId) {
                Phoneid = 0;
                Emailid = 0;
                this.setState({ Phones: this.state.Phones = '', Emails: this.state.Emails = '', updatedPhoneKeys: [], needUpdateEmailKeys: [] });
                this.renderPhones(nextprops.profileinfo);
                this.renderEmail(nextprops.profileinfo);
            }
        }
    }

    gettypes = () => {
        if (this.props.communicationtypes) {
            let communicationtypes = this.props.communicationtypes
            return communicationtypes.map((k, index) => {
                if (k.classificationId == "1") {
                    return (
                        <option key={index} value={k.id}>{k.name}</option>
                    )
                }
            })
        }
    }

    getemailtype = () => {
        if (this.props.communicationtypes) {
            let communicationtypes = this.props.communicationtypes
            return communicationtypes.map((k, index) => {
                if (k.classificationId == "3") {
                    return (
                        <option key={index} value={k.id}>{k.name}</option>
                    )
                }
            })
        }
    }

    removeEmail = k => {
        const { form } = this.props;
        const emailkeys = form.getFieldValue('emailkeys');
        if (emailkeys.length === 1) {
            return;
        }
        form.setFieldsValue({
            emailkeys: emailkeys.filter(key => key !== k),
        });
    };

    renderEmail = (profileinfo) => {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        let email = profileinfo.emails
        if (this.state.Email == "") {
            this.setState({
                Emails: email,
                needUpdateEmailKeys: []
            }, () => {
                email.map((k, index) => {
                    if (k.isPrimary == "True") {
                        this.setState({
                            currentPrimaryEmail: k,
                            PrimaryEmailSelected: index,
                            EmailRadioid: index
                        })
                    }
                    this.addEmail()
                });
            });
        }
    }

    removePhone = k => {
        const { form } = this.props;
        const phonekeys = form.getFieldValue('phonekeys');
        if (phonekeys.length === 1) {
            return;
        }
        form.setFieldsValue({
            phonekeys: phonekeys.filter(key => key !== k),
        });
    };

    addPhone = () => {
        const { form } = this.props;
        const phonekeys = form.getFieldValue('phonekeys') ? form.getFieldValue('phonekeys') : [];
        const nextKeys = phonekeys.concat(Phoneid++)
        form.setFieldsValue({
            phonekeys: nextKeys,
        });
        if (this.props.profileinfo.phones.length == 0) {
            this.SelectPrimary(0)
        }
    };

    addEmail = () => {
        const { form } = this.props;
        const emailkeys = form.getFieldValue('emailkeys');
        const nextKeys = emailkeys ? emailkeys.concat(Emailid++) : 0
        form.setFieldsValue({
            emailkeys: nextKeys,
        });
    };


    renderPhones = (profileinfo) => {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        let phone = profileinfo.phones
        if (this.state.Phones == "") {
            this.setState({
                Phones: phone,
                needUpdatePhoneKeys: []
            }, () => {
                phone.map((k, index) => {
                    if (k.isPrimary == "True") {
                        this.setState({
                            currentPrimaryPhone: k,
                            PrimarySelected: index,
                            Radioid: index
                        })
                    }
                    this.addPhone()
                });
            });
        }
    }


    renderEditValues = (profileinfo) => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'YYYY/MM/DD';
        const { firstName } = this.state;
    }

    SelectPrimary = (value) => {
        console.log(value)
        this.setState({
            PrimarySelected: value,
            Radioid: value
        })
    }
    SelectPrimaryEmail = (value) => {
        console.log(value)
        this.setState({
            PrimaryEmailSelected: value,
            EmailRadioid: value
        })
    }

    getUpdatedPhoneKey = (value) => {
        let updatedPhoneKeys = this.state.needUpdatePhoneKeys;

        // if (!updatedPhoneKeys.includes(value)) {
        if (updatedPhoneKeys.indexOf(value) == -1) {
            updatedPhoneKeys.push(value)
        }
        updatedPhoneKeys = updatedPhoneKeys.sort((a, b) => a - b);
        this.setState({ needUpdatePhoneKeys: updatedPhoneKeys })
    }
    getUpdatedEmailKey = (value) => {
        let updatedEmailKeys = this.state.needUpdateEmailKeys;

        // if (!this.updatedEmailKeys.includes(value)) {
        if (updatedEmailKeys.indexOf(value) == -1) {
            updatedEmailKeys.push(value)
        }
        updatedEmailKeys = updatedEmailKeys.sort((a, b) => a - b);

        let emailType = [...this.state.emailType];
        delete emailType[updatedEmailKeys.indexOf(value)]
        this.setState({
            needUpdateEmailKeys: updatedEmailKeys,
            emailType,
        })
    }
    changeEmailType = (value, index) => {

        if (value != '') {
            let emailType = [...this.state.emailType];
            delete emailType[index] //remove the err array item
            this.setState({
                emailType,
            })
        }
    }

    handleSubmit = async (e) => {
        try {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    let isUndeliverable = false
                    if (this.state.isUndeliverable) {
                        this.state.email == values.email ? isUndeliverable = true : isUndeliverable = false
                    }
                    this.setState({
                        emailType: []
                    })
                    // if (this.state.email == values.email) {
                    //     notification['error']({
                    //         message: 'Error',
                    //         description:
                    //             'Please update the deliverable email address!',
                    //     });
                    // } else {
                    this.props.actions.showContactMsg(this.props.profileinfo.profile.personGuid, 'admin')

                    this.props.actions.updateProfilePhone(this.props.profileinfo.profile.personGuid, this.state.PrimarySelected, this.state.currentPrimaryPhone, this.state.PrimaryEmailSelected, this.state.currentPrimaryEmail, values, 'admin', this.state.needUpdatePhoneKeys, this.state.needUpdateEmailKeys)
                    // this.props.actions.updateMyEmail(this.state.personGUID, this.state.EmailId, values, this.state.EmailTypeId, 'admin', isUndeliverable)
                    //this.props.actions.updateProfilePhone(this.state.personGUID, this.state.PrimarySelected, this.state.currentPrimaryPhone, values, 'admin')
                    // }
                } else {
                    if (err.emailtype) {
                        console.log('errType' + err);
                        this.setState({
                            emailType: err.emailtype
                        })
                    }
                    else {
                        this.setState({
                            emailType: []
                        })
                    }
                }
            });
        }
        catch (error) {
            console.log(error);
            Notification(
                'error',
                `Oops! Error occured. ${error.response.data.message}`,
            );
        }
    }

    renderEditEmailValues = (profileinfo) => {
        let email = '';
        if (Array.isArray(profileinfo.emails) && profileinfo.emails.length > 0) {
            email = profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0]
        }
        if (this.state.EmailId == '' || this.state.EmailTypeId == '') {
            this.setState({
                EmailId: email ? email.id : "0",
                EmailTypeId: email ? email.typeId : "0",
                email: email ? email.email : ""
            })
        }

        if (email) {
            if (email.isUndeliverable) {
                if (!this.state.isUndeliverable) {
                    this.setState({
                        isUndeliverable: true
                    })
                }
            }
        }

        const { getFieldDecorator, getFieldValue } = this.props.form;
            getFieldDecorator('emailkeys', { initialValue: [] });
            const emailkeys = getFieldValue('emailkeys');
            const EmailItems = emailkeys.map((k, index) => (
                <Row className='contact-info' type="flex" justify="start" align="middle">
                    <Col className='primary-container' xs={3} sm={3} md={3} lg={3} xl={3}>
                        <FormItem
                            className='primary-txt'
                            label={index === 0 ? 'Primary' : ''}
                        >
                            {getFieldDecorator(`primaryEmail[${k}]`, {
                                // initialValue: this.state.Phones[k] ? this.state.Phones[k].id : "",
                                // if(this.state.Phones[k] ? (this.state.Phones[k].isPrimary == "True"){
                                // };
                                initialValue: this.state.Emails[k] ? this.state.Emails[k].id : "",
                            })(
                                // <Radio key={k} value={k} onChange={() => this.SelectPrimary(k)} checked={(this.state.Phones[k] ? (this.state.Phones[k].isPrimary == "True" ? true : false) : false)}></Radio>
                                <Radio key={k} value={k} onChange={() => this.SelectPrimaryEmail(k)} checked={this.state.EmailRadioid === k && true}></Radio>
                                // <Radio key={k} value={k} onChange={() => this.SelectPrimary(k)} checked={this.state.Phones[k] ? (this.state.Phones[k].isPrimary == "True" ? true : false) : false}></Radio>
                            )}
                        </FormItem>

                    </Col>
                    <Col xs={21} sm={21} md={15} lg={15} xl={15}>
                        <FormItem hasFeedback
                            //label={index === 0 ? `Email` : ''}
                            className="scondary email"
                        >
                            {getFieldDecorator(`email[${k}]`, {
                                initialValue: (this.state.Emails[k]) ? this.state.Emails[k].email : "",
                                rules: [{ required: true, type: "email", message: 'Enter valid email address!' },
                                { max: 50, message: 'Email must be maximum 50 characters.' },
                                ]
                            })(
                                <Input addonBefore={
                                    getFieldDecorator(`emailtype[${k}]`, {
                                        rules: [{ required: true, message: 'Select email type' }],
                                        initialValue: this.state.Emails[k] ? this.state.Emails[k].typeId : "",
                                    })(
                                        <Select onChange={(value) => this.changeEmailType(value, k)} style={{ width: 160 }}>
                                            {this.getemailtype()}
                                        </Select>
                                    )
                                } placeholder='Email Address'
                                    onChange={() => this.getUpdatedEmailKey(k)}
                                />
                            )}
                        </FormItem>
                        {this.state.emailType ? this.state.emailType[k] ?
                            <div className='custom-alert'>
                                Select email type!
                                </div> : '' : ''
                        }
                    </Col>
                    <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                        <FormItem>
                            {emailkeys.length > 1 ? (
                                this.state.Emails[k] ?
                                    this.state.Emails[k].isPrimary == 'False' ?
                                        <Popconfirm placement="top" title="Are you sure to delete this Email?" onConfirm={() => this.props.actions.deleteEmail(this.props.profileinfo.profile.personGuid, this.state.Emails[k].id, "admin")} okText="Yes" cancelText="No">
                                            <i className="fa fa-trash-o red pointer fa-lg" aria-hidden="true" ></i>
                                        </Popconfirm> : null
                                    : <Popconfirm placement="top" title="Are you sure to delete this Email?" onConfirm={() => this.removeEmail(k)} okText="Yes" cancelText="No">
                                        <i className="fa fa-trash-o red pointer fa-lg" aria-hidden="true" ></i>
                                    </Popconfirm>
                            ) : null}
                        </FormItem>
                    </Col>
                </Row>
            ));
            getFieldDecorator('phonekeys', { initialValue: [] });
            const phonekeys = getFieldValue('phonekeys');
            const PhoneItems = phonekeys.map((k, index) => (
                <Row className='contact-info' type="flex" justify="space-around" align="middle">
                    <Col className='primary-container' xs={3} sm={3} md={3} lg={3} xl={3}>
                        <FormItem
                            className='primary-txt'
                            label={index === 0 ? 'Primary' : ''}
                        >
                            {getFieldDecorator(`primary[${k}]`, {
                                // initialValue: this.state.Phones[k] ? this.state.Phones[k].id : "",
                                // if(this.state.Phones[k] ? (this.state.Phones[k].isPrimary == "True"){

                                // };
                                initialValue: this.state.Phones[k] ? this.state.Phones[k].id : "",
                            })(
                                // <Radio key={k} value={k} onChange={() => this.SelectPrimary(k)} checked={(this.state.Phones[k] ? (this.state.Phones[k].isPrimary == "True" ? true : false) : false)}></Radio>
                                // <Radio key={k} value={k} onChange={() => this.SelectPrimary(k)} checked={this.state.Radioid === k && true}></Radio>
                                <Radio key={k} onChange={() => this.SelectPrimary(k)} checked={this.state.PrimarySelected === k ? true : false}></Radio>
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={21} sm={21} md={8} lg={8} xl={8}>
                        <FormItem
                            label={index === 0 ? 'Types' : ''}
                        >
                            {getFieldDecorator(`phoneTypeID[${k}]`, {
                                initialValue: this.state.Phones[k] ? this.state.Phones[k].typeId : "",
                                rules: [{ required: true, message: 'Enter Phone Types!' }],
                            })(
                                <Select style={{ width: '100%' }}>
                                    {this.gettypes()}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col xs={21} sm={21} md={11} lg={11} xl={11}>
                        <FormItem hasFeedback
                            label={index === 0 ? `Phone` : ''}
                        >
                            {getFieldDecorator(`phone[${k}]`, {
                                initialValue: (this.state.Phones[k] && this.state.Phones[k].countryId) ? (this.state.Phones[k].countryId == "636") ? (this.state.Phones[k] ? (this.state.Phones[k].areaCode + this.state.Phones[k].prefix + this.state.Phones[k].lineNumber) : "") : (this.state.Phones[k].lineNumber) : this.state.Phones[k] ? (this.state.Phones[k].fullPhoneNumber.replaceAll(/ /g, '')) : '',
                                rules: [{ required: true, min: 7, max: 15, message: 'Must be between 7 and 15 characters!' },
                                { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
                            })(
                                <Input
                                    addonBefore={
                                        getFieldDecorator(`phonecountryID[${k}]`, {
                                            rules: [{ required: true, message: 'Select Phone Country ID' }],
                                            initialValue: this.state.Phones[k] && this.state.Phones[k].countryId ? (typeof myVar === 'string' ? this.state.Phones[k].countryId : this.state.Phones[k].countryId.toString()) : "636",
                                        })(
                                            <Select style={{ width: 130 }} ref={this.selectphonecountryIDRef} onSelect={() => this.selectphonecountryIDRef.current.blur()}>
                                                {this.getPhoneCode()}
                                            </Select>
                                        )
                                    } placeholder="Phone"
                                    onChange={() => { this.getUpdatedPhoneKey(k) }}
                                />

                            )}
                        </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                        <FormItem>
                            {phonekeys.length > 1 ? (
                                this.state.Phones[k] ?
                                    this.state.Phones[k].isPrimary == 'False' ?
                                        <Popconfirm placement="top" title="Are you sure to delete this Phone?" onConfirm={() => this.props.actions.deletemobile(this.props.profileinfo.profile.personGuid, this.state.Phones[k].id, "admin")} okText="Yes" cancelText="No">
                                            <i className="fa fa-trash-o red pointer fa-lg" aria-hidden="true" ></i>
                                        </Popconfirm> : null
                                    : <Popconfirm placement="top" title="Are you sure to delete this Phone?" onConfirm={() => this.removePhone(k)} okText="Yes" cancelText="No">
                                        <i className="fa fa-trash-o red pointer fa-lg" aria-hidden="true" ></i>
                                    </Popconfirm>
                            ) : null}
                        </FormItem>
                    </Col>
                </Row>
            ));
            return (
                <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                        <Form onSubmit={this.handleSubmit} className="alumni-ui contact-form">
                            <div className='edit-mode my-profile'>
                                <span className='span-heading'>Email</span>
                                {/* <Row type='flex' justify='start'>
                                    <Col className='primary-container' xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <FormItem
                                            className='primary-txt'
                                            label='Primary'
                                        >
                                            {getFieldDecorator(`primaryemail`, {
                                                initialValue: true,
                                            })(
                                                <Radio checked></Radio>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <FormItem hasFeedback
                                            label="Email"
                                        >
                                            {getFieldDecorator('email', {
                                                initialValue: email ? email.email : "",
                                                rules: [{ required: true, type: 'email', message: 'Enter valid email address!' }],
                                            })(
                                                <Input placeholder="Email" />
                                            )}
                                        </FormItem>
                                        {email ? email.isUndeliverable &&
                                            <Alert message="Please update the deliverable email address" type="error" showIcon /> : ""}
                                    </Col>
                                </Row> */}
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        {EmailItems}
                                        <FormItem>
                                            <span className='add-another pointer' onClick={this.addEmail} >
                                                <Icon type="plus-circle" /> Add Email Address
                                        </span>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <span className='span-heading'>Phones</span>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        {PhoneItems}
                                        <FormItem>
                                            <span className='add-another pointer' onClick={this.addPhone} >
                                                <Icon type="plus-circle-o" /> Add another phone
                                        </span>
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row type='flex' className='btn-action' justify='space-around'>
                                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                                        <Row type='flex' justify='space-around' style={{ alignItems: 'center' }}>
                                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                                <FormItem>
                                                    <Button id="maintainpfle-cnt-cl-btn" onClick={(e) => this.cancelActions(e)} className="myprofile-cancel-btn" >CANCEL</Button>
                                                </FormItem>
                                            </Col>
                                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                                <FormItem>
                                                    <Button id="maintainpfle-cnt-su-btn" className="save-change-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                </Collapse>
            )
    }

    renderEditView = () => {
        if (this.props.updating) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Updating Information..." />)
        }else if (this.props.loading) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Loading Information..." />)
        }else if (this.props.profileinfo && !this.props.loading && !this.props.updating) {
            return this.renderEditEmailValues(this.props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
        }
    }

    render() {
        return (
            <div>
                <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                    <Panel header="Constituent Contact Information" key="1" style={customPanelStyle}>
                        {this.renderEditView()}
                    </Panel>
                </Collapse>
            </div>   
        )
    }
}


function mapStateToProps(state) {
    return {
        loading: state.alumniinforeducer.loading,
        profileinfo: state.alumniinforeducer.profileinfo,
        countries: state.countriesreducer.countries,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        statuses: state.maritalstatusreducer.status,
        communicationtypes: state.communcationtypesreducer.types,
        phonecode: state.phonecountrycodereducer.code,
        updating: state.alumniemailupdatereducer.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
const ContactInfo = Form.create()(ContactInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(ContactInfo);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/alumniContact.js